import { useState, useEffect, useRef } from 'react'
import Notification from './components/Notification'
import Results from './components/Results'
import EntryForm from './components/EntryForm'
import entryService from './services/entry_service'
import TeamList from './components/TeamList'

const App = () => {
  const [entries, setEntries] = useState([])
  const [errorMessage, setErrorMessage] = useState(null)

  useEffect(() => {
    entryService
      .getAll()
      .then(initialEntries => {
        setEntries(initialEntries)
      })
  }, [])

  const addEntry = (teamObject) => {
    entryService
      .create(teamObject)
      .then(returnedTeam => {
        setEntries(entries.concat(returnedTeam))
      })
  }

  const entryForm = () => (
      <EntryForm addEntry={addEntry} />
  )


  return (
    <div>
      <h1>Kyläviesti - Byakampen 2024</h1>

      <Notification message={errorMessage} />

      {entryForm()}

      <TeamList teams={entries} />

      <Results />
    </div>
  )
}

export default App